/**
 * Author: Paul Grejaldo
 * Date: 5/3/20
 * Time: 11:50 AM
 */
( function () {
	'use strict';

	const flh = {
		init : () => {
			const select = document.querySelector( '.item-selector' );

			if ( select ) {
				select.addEventListener( 'change', flh.onItemChange );
			} else {
				document.querySelector( 'body' ).addEventListener( 'change', flh.onItemChange );
			}
		},

		onItemChange : ( event ) => {
			const { value } = event.target;

			const isFlhBlock = event.target.closest( '.foundry-list-highlights-container' );
			if ( !isFlhBlock ) {
				return;
			}
			const isItemSelector = event.target.classList.contains( 'item-selector' );
			if ( !isItemSelector ) {
				return;
			}
			const newActive = document.querySelector( `#flh-item-${ value }` );

			const activeItem = document.querySelector( '.flh-item.active' );
			activeItem.classList.remove( 'active' );
			newActive.classList.add( 'active' );
		},
	};

	flh.init();
} )();
